import React from "react";
import clsx from "clsx";

const Button = ({
  children,
  variant = "primary",
  size = "sm",
  fullWidth = false,
  className,
  onClick,
  disabled,
  isLoading,
  icon,
  style,
  ...props
}) => {
  const baseClasses =
    "rounded-full cursor-pointer font-medium transition focus:outline-none";

  const variantClasses = {
    primary:
      "bg-brand-gradient text-center text-white hover:bg-gradient-to-r hover:from-[#2BACE2] hover:to-[#2E398A]/90",
    secondary: "bg-gray-300 text-gray-900 hover:bg-gray-400",
    danger: "bg-red-500 text-white hover:bg-red-600",
    normal: "bg-transparent text-[#2BACE2]",
  };

  const sizeClasses = {
    xs: "px-3 py-2 text-xs",
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  return (
    <button
      disabled={disabled || isLoading}
      style={style}
      className={clsx(
        baseClasses,
        variantClasses[disabled ? "secondary" : variant],
        sizeClasses[size],
        fullWidth && "w-full",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {isLoading ? (
        <div class="flex items-center justify-center ">
          <div class="w-6 h-6 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="flex items-center gap-2 justify-center">
          {icon} {children}
        </div>
      )}
    </button>
  );
};

export default Button;
